import React, { useEffect, useState } from "react";

import TopNav from "./TopNav";
import TopNavMobile from "./TopNavMobile";

export default function ResponsiveTopNav() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <TopNavMobile /> : <TopNav />;
}